import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import CountrySelectorBanner from '../country-selector-banner'
import KenwoodHeader from '../kenwood-header'
import {DrawerMenu} from '../drawer-menu'
import {ListMenu} from '../list-menu'
import {ListMenu as KenwoodListMenu, DrawerMenu as KenwoodDrawerMenu} from '../kenwood-menu'
import {HideOnDesktop, HideOnMobile} from '@salesforce/retail-react-app/app/components/responsive'
import Header from '../header'
import {BRAND_KEY} from '../../brand'
import {Box, useDisclosure} from '@chakra-ui/react'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useHistory} from 'react-router-dom'
import {SelectorModal} from '../footer/country-selector'
import {useCurrentCustomer} from '../../hooks/use-current-customer'

const MultisiteHeader = () => {
    const {locale, buildUrl} = useMultiSite()
    const navigate = useNavigation()
    const history = useHistory()
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [isCountrySelectorOpen, setIsCountrySelectorOpen] = useState(false)
    const {data: customer} = useCurrentCustomer()

    const intl = useIntl()

    const onLogoClick = () => {
        navigate(`/${locale?.alias}`)
        onClose()
    }

    const onCartClick = () => {
        const path = buildUrl('/cart')
        history.push(path)

        // Close the drawer.
        onClose()
    }

    const onAccountClick = () => {
        // Link to account page if registered; Header component will show auth modal for guest users
        const path = buildUrl('/account')
        history.push(path)
    }

    const onWishlistClick = () => {
        // Link to wishlist page if registered; Header component will show auth modal for guest users
        let path
        if (customer?.isRegistered) {
            path = buildUrl('/account/wishlist')
        } else {
            path = buildUrl('/wishlist')
        }
        history.push(path)
    }

    const HEADER_COMPONENTS = {
        kenwood: KenwoodHeader,
        delonghi: Header,
        nutribullet: Header,
    }
    const LIST_MENU_COMPONENTS = {
        kenwood: KenwoodListMenu,
        delonghi: ListMenu,
        nutribullet: ListMenu,
    }
    const DRAWER_MENU_COMPONENTS = {
        kenwood: KenwoodDrawerMenu,
        delonghi: DrawerMenu,
        nutribullet: DrawerMenu,
    }

    const MappedHeaders = HEADER_COMPONENTS[BRAND_KEY] ?? Header

    const MappedListMenus = LIST_MENU_COMPONENTS[BRAND_KEY] ?? ListMenu

    const MappedDrawerMenus = DRAWER_MENU_COMPONENTS[BRAND_KEY] ?? DrawerMenu

    return (
        <Box pos="relative" zIndex={1}>
            <CountrySelectorBanner
                onSelectAnotherCountry={() => {
                    setIsCountrySelectorOpen(true)
                }}
            />

            {isCountrySelectorOpen && (
                <SelectorModal
                    isOpen={isCountrySelectorOpen}
                    onClose={() => setIsCountrySelectorOpen(false)}
                    intl={intl}
                />
            )}

            <MappedHeaders
                onMenuClick={onOpen}
                onLogoClick={onLogoClick}
                onMyCartClick={onCartClick}
                onMyAccountClick={onAccountClick}
                onWishlistClick={onWishlistClick}
                isOpen={isOpen}
            >
                <MappedDrawerMenus
                    isOpen={isOpen}
                    onClose={onClose}
                    onWishlistClick={onWishlistClick}
                />

                <HideOnDesktop>
                    <MappedDrawerMenus
                        isOpen={isOpen}
                        onClose={onClose}
                        onWishlistClick={onWishlistClick}
                    />
                </HideOnDesktop>

                <HideOnMobile>
                    <MappedListMenus />
                </HideOnMobile>
            </MappedHeaders>
        </Box>
    )
}

export default MultisiteHeader
